import { Type, type Static } from "@sinclair/typebox";
const fields = {
  date: Type.String({ format: "date" }),
  description: Type.String({ minLength: 1, maxLength: 4000 }),
  amount: Type.Number({ exclusiveMinimum: 0, maximum: 99999999999.99 }),
  contractAmount: Type.Optional(
    Type.Number({ minimum: 0, maximum: 999999999.99 }),
  ),
  materialsCost: Type.Optional(
    Type.Number({ minimum: 0, maximum: 999999999.99 }),
  ),
  materialsMarkupPercent: Type.Optional(
    Type.Number({ minimum: 0, maximum: 1000 }),
  ),
  vatId: Type.Integer({ minimum: 1 }),
  vatPercent: Type.Number({ minimum: 0, maximum: 100 }),
};
export const LifelineBillingPreviewSchema = Type.Object(fields, {
  additionalProperties: false,
});
export const LifelineBillingCreateSchema = Type.Object(
  {
    ...fields,
    operationId: Type.String({ format: "uuid" }),
    confirmed: Type.Literal(true),
  },
  { additionalProperties: false },
);
export type LifelineBillingInput = Static<typeof LifelineBillingPreviewSchema>;
export type LifelineBillingCreate = Static<typeof LifelineBillingCreateSchema>;
export interface LifelineBillingIntervention {
  id: string;
  date: string;
  description: string;
  amount: string | null;
  materialsCost?: string;
  pricing?: LifelineBillingInput | null;
  sourceDocumentId: string | null;
  sourceNumber: string | null;
  invoiceId: string | null;
  invoiceNumber: string | null;
  invoiceStatus: string | null;
  activeOperation: {
    operationId: string;
    status: "pending" | "verification-required";
    input: LifelineBillingInput;
  } | null;
}
